module.exports={render:function (){with(this) {
  return _h('footer', {
    staticClass: "ion-footer",
    class: [cTheme]
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f6a39aac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/src/footer.vue
// module id = 170
// module chunks = 0